import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponse, handleError } = handlers;

function getConfig(machineID) {
  const requestOptions = {
    method: 'GET',
    url: `/configs/agentconfig/${machineID}`
  };

  return crFetch(requestOptions).then(handleResponse, handleError);
}

function getSetup(machineID) {
  const requestOptions = {
    method: 'GET',
    url: `/configs/agentconfig/setup/${machineID}`
  };

  return crFetch(requestOptions).then(handleResponse, handleError);
}

function validate(machineID, agentConfig) {
  const requestOptions = {
    method: 'POST',
    url: `/configs/agentconfig/validate/${machineID}`,
    body: JSON.stringify(agentConfig)
  };

  return crFetch(requestOptions).then(handleResponse, handleError);
}

function update(machineID, agentConfig) {
  const requestOptions = {
    method: 'PUT',
    url: `/configs/agentconfig/${machineID}`,
    body: JSON.stringify(agentConfig)
  };

  return crFetch(requestOptions).then(handleResponse, handleError);
}

const configService = {
  getConfig,
  update,
  getSetup,
  validate
};

export default configService;
